<template>
  <div class="garage-adsense">
    <div class="garage-adsense__container">
      <!-- DobryMechanik.pl - elastyczny billboard -->
      <ins
        class="adsbygoogle"
        style="display:block"
        data-ad-client="ca-pub-5453692719230487"
        data-ad-slot="3585239739"
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  </div>
</template>

<script setup lang="ts">
import { loadScript } from '~/helpers/helpers';

onMounted(() => {
  loadScript("https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5453692719230487", true, "anonymous")
    .then(() => {
      (adsbygoogle = window.adsbygoogle || []).push({});
    });
});
</script>

<style lang="scss" scoped>
.garage-adsense {
  display: flex;
  justify-content: center;


  &__container {
    width: 100%;
    max-width: 1280px;
    padding: 0 14px;
  }
}
</style>